module.exports = __webpack_public_path__ + "static/media/gif2.d68a3b40.gif";